import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="w-full pt-48 pb-32 px-6 lg:px-12 min-h-[70vh] max-w-screen-2xl mx-auto">
      <p className="text-sm uppercase tracking-widest text-gray-400 font-bold mb-6">Errore 404</p>
      <h1 className="text-5xl md:text-7xl font-bold tracking-tighter mb-8">Pagina non trovata</h1>
      <p className="text-xl font-light text-gray-600 mb-12 max-w-xl">La pagina che cerchi non esiste o è stata spostata.</p>
      <Link to="/" data-testid="not-found-home-link" className="inline-block bg-black text-white px-10 py-5 uppercase text-sm font-bold tracking-[0.2em] hover:bg-[#7dba00] transition-colors">
        Torna alla Home
      </Link>
    </div>
  );
}
